// Central tag constants for Adobe / internal page view tracking.
// NOTE: Values currently follow a simple normalization pattern: lowercase of key after 'OM_'.
// Replace placeholder values with definitive spreadsheet-driven tags as they are confirmed.
// When updating, ensure any route mapping in findRouteConfig.ts stays in sync.

// NOTE: Expanded set below generated from latest provided list. Typos normalized to underscores;
// duplicates collapsed. If spreadsheet differs, update VALUE strings (not keys) to match canonical tag.
export const TAGS = {
  OM_HOMEPAGE: 'om_homepage',
  OM_ABOUT_US: 'om_about_us',
  OM_CONTACT_US: 'om_contact_us',
  OM_FAQ: 'om_faq',
  OM_SETTINGS: 'om_settings',
  OM_PRIVACY_POLICY: 'om_privacy_policy',
  OM_TERMS_OF_USE: 'om_terms_of_use',
  // Clinician-specific static pages
  OM_CL_ABOUT_US: 'om_cl_about_us',
  OM_CL_CONTACT_US: 'om_cl_contact_us',
  OM_CL_CLINICAL_ASSISTANCE: 'om_cl_clinical_assistance',
  OM_CL_FAQ: 'om_cl_faq',
  OM_CL_SETTINGS: 'om_cl_settings',
  OM_CL_PRIVACY_POLICY: 'om_cl_privacy_policy',
  OM_CL_TERMS_OF_USE: 'om_cl_terms_of_use',
  // Patient high-level pages
  OM_PA_PRIVACY: 'om_pa_privacy',
  OM_PA_LOGIN: 'om_pa_login',
  OM_PA_EXPECTATION: 'om_pa_expectation',
  OM_PA_BEGIN_SEARCH: 'om_pa_begin_search', // provided as begin-search; normalized
  OM_PA_DISCLAIMER: 'om_pa_disclaimer',
  OM_PA_ACCESS_WALL: 'om_pa_access_wall',
  OM_PA_MINOR: 'om_pa_minor',
  OM_PA_MY_MATCHES: 'om_pa_my_matches',
  OM_PATIENT_ACTIVITY: 'om_patient_activity',
  // Patient survey + background sections
  OM_PA_PC_SECTION_BACKGROUND: 'om_pa_pc_section_background',
  OM_PA_PC_SECTION_AMENITIES: 'om_pa_pc_section_amenities',
  OM_PA_PC_SECTION_CARE_APPROACH: 'om_pa_pc_section_care_approach',
  OM_PA_PC_SECTION_COMM_STYLE: 'om_pa_pc_section_comm_style',
  // Patient survey review / feedback
  OM_PA_SURVEY_REVIEW: 'om_pa_survey_review',
  OM_PA_SURVEY_FEEDBACK: 'om_pa_survey_feedback',
  // Patient background details
  OM_PA_PC_BACKGROUND_LANGUAGE_SELECT: 'om_pa_pc_background_language_select',
  OM_PA_PC_BACKGROUND_LANGUAGE_SERVICE: 'om_pa_pc_background_language_service',
  OM_PA_PC_BACKGROUND_PRONOUN_YN: 'om_pa_pc_background_pronoun_yn',
  OM_PA_PC_BACKGROUND_PRONOUN_SELECT: 'om_pa_pc_background_pronoun_select',
  OM_PA_PC_BACKGROUND_GENDER_SELECT: 'om_pa_pc_background_gender_select',
  OM_PA_PC_BACKGROUND_YN: 'om_pa_pc_background_yn',
  OM_PA_PC_BACKGROUND_ETHNICITY_YN: 'om_pa_pc_background_ethnicity_yn',
  OM_PA_PC_BACKGROUND_RACE_ETHNICITY_SELECT:
    'om_pa_pc_background_race_ethnicity',
  OM_PA_PC_BACKGROUND_RACE_ETHNICITY_YN:
    'om_pa_pc_background_doctor_similar_race_etnicity',
  OM_PA_PC_BACKGROUND_SEXUAL_ORIENTATION_SELECT:
    'om_pa_pc_background_sexual_orientation_select',
  OM_PA_PC_BACKGROUND_SEXUAL_ORIENTATION_YN: 'om_pa_pc_backgroundsexual_yn',
  OM_PA_PC_BACKGROUND_RACE_ETHNICITY_YN_SELECT:
    'om_pa_pc_background_race_ethnicity_yn + pc_background_race_ethnicity_select',
  OM_PA_PC_BACKGROUND_MILITARY_YN: 'om_pa_pc_background_military_yn',
  OM_PA_PC_BACKGROUND_MILITARY_SELECT: 'om_pa_pc_background_military_select',
  OM_PA_PC_BACKGROUND_DOB: 'om_pa_pc_background_dob',
  OM_PA_PC_BACKGROUND_YOE: 'om_pa_pc_background_yoe',
  OM_PA_PC_BACKGROUND: 'om_pa_pc_background',
  // Patient amenities
  OM_PA_PC_AMENITIES_OFFICE: 'om_pa_pc_amenities_office',
  OM_PA_PC_AMENITIES_DOCTOR_OFFICE_AMENITIES:
    'om_pa_pc_amenities_doctor_office_amenities',
  OM_PA_PC_AMENITIES_CONVENIENCE: 'om_pa_pc_amenities_convenience',
  OM_PA_PC_AMENITIES_ADDITIONAL_CERTIFIED:
    'om_pa_pc_amenities_additional+pc_amenities_integrated_certified',
  OM_PA_PC_AMENITIES_DIGITAL: 'om_pa_pc_amenities_digital',
  OM_PA_PC_AMENITIES_ADDITIONAL: 'om_pa_pc_amenities_additional',
  OM_PA_PC_AMENITIES_INTEGRATED_CERTIFIED_SERVICES_DOCTOR_OFFICE:
    'om_pa_pc_amenities_integrated_certified_services_doctor_office',
  OM_PA_PC_AMENITIES_INTEGRATED: 'om_pa_pc_amenities_integrated',
  OM_PA_PC_AMENITIES_CONVENIENCE_SERVICES:
    'om_pa_pc_amenities_office +pc_amenities_convenience',
  OM_PA_PC_AMENITIES_INTEGRATED_CERTIFIED_SERVICES:
    'om_pa_pc_amenities_integrated_certified_services',

  // Patient communication style
  OM_PA_PC_COMM_STYLE_LEAD_CONVO: 'om_pa_pc_comm_lead_convo',
  OM_PA_PC_COMM_STYLE_DECISION_MAKER: 'om_pa_pc_comm_decision_maker',
  OM_PA_PC_COMM_STYLE_SYMPTOMS_RESEARCH:
    'om_pa_pc_comm_style_symptoms_research',
  OM_PA_PC_COMM_STYLE_DIAGNOSIS_TREATMENT:
    'om_pa_pc_comm_style_diagnosis_treatment',
  OM_PA_PC_COMM_STYLE_LIST_QS: 'om_pa_pc_comm_style_list_qs',
  OM_PA_PC_COMM_STYLE_APPOINTMENT_PREF_DOCTOR:
    'om_pa_pc_comm_appointment_prefer_doctor',
  OM_PA_PC_COMM_STYLE_JOB_HEALTHY: 'om_pa_pc_comm_style_job_healthy',
  OM_PA_PC_COMM_STYLE_ANOTHER_CLINICIAN:
    'om_pa_pc_comm_style_another_clinician',
  OM_PA_PC_COMM_STYLE_CASUAL_OR_PROF: 'om_pa_pc_comm_style_casual_or_prof',
  OM_PA_PC_COMM_STYLE_PRAYING_YN: 'om_pa_pc_comm_style_praying_yn',
  OM_PA_PC_COMM_STYLE_DOCTOR_EXPLAINS_THINGS:
    'om_pa_pc_comm_style_doctor_explains_things',
  OM_PA_PC_COMM_EDUCATIONAL_MATERIALS_DOCTOR:
    'om_pa_pc_comm_educational_materials_doctor',
  // Patient care approach
  OM_PA_PC_CARE_APPROACH: 'om_pa_pc_care_approach',
  OM_PA_PC_CARE_APPROACH_CLINICAL_SERVICE:
    'om_pa_pc_care_approach_clinical_service',
  OM_PA_PC_CARE_APPROACH_NATURAL_INTEGRATIVE_SELECT:
    'om_pa_pc_care_approach_natural_integrative_select',
  OM_PA_PC_CARE_APPROACH_NATURAL_INTEGRATIVE_TREATMENTS:
    'om_pa_pc_care_approach_natural_integrative_treatments',
  OM_PA_PC_CARE_APPROACH_DIET_SUPPORT: 'om_pa_pc_care_approach_diet_support',
  OM_PA_PC_CARE_APPROACH_DIET_SELECT: 'om_pa_pc_care_approach_diet_select',
  OM_PA_PC_CARE_APPROACH_KNOWLEDGE_EXP: 'om_pa_pc_care_approach_knowledge_exp',
  OM_PA_PC_CARE_APPROACH_MANAGE_PROBLEM:
    'om_pa_pc_care_approach_manage_problem', // normalize typo problen
  OM_PA_PC_CARE_APPROACH_VACCINE: 'om_pa_pc_care_approach_vaccine',
  // Patient zip code
  OM_PA_ZIP_CODE_NOT_AVAILABLE: 'om_pa_zip_code_not-available',
  // Clinician high-level pages
  OM_CL_LOGIN: 'om_cl_login',
  OM_CL_EXPECTATION: 'om_cl_expectation',
  OM_CL_PRIVACY: 'om_cl_privacy',
  OM_CL_SURVEY_REVIEW: 'om_cl_survey_review',
  OM_CL_MANAGE_RESPONSES: 'om_cl_manage_responses',
  // New distinct clinician dashboard & home tags (avoid overloading login tag)
  OM_CL_DASHBOARD: 'om_cl_dashboard',
  OM_CL_HOME: 'om_cl_home',
  // Clinician profile
  OM_CL_MY_PROFILE: 'om_cl_my_profile',
  // Clinician survey feedback
  OM_CL_SURVEY_FEEDBACK: 'om_cl_survey_feedback',
  // Clinician background
  OM_CL_PC_BACKGROUND: 'om_cl_pc_background',
  OM_CL_PC_BACKGROUND_PRONOUN_YN_SELECT:
    'om_pa_pc_background_pronoun_yn +pc_ background_pronoun_select',
  OM_CL_PC_BACKGROUND_GENDER_SELECT: 'om_cl_pc_background_gender_select',
  OM_CL_PC_BACKGROUND_RACE_ETHNICITY_SELECT:
    'om_cl_pc_background_race_ethnicity_select',
  // Alias for spreadsheet typo 'etnicity' (retain for matching legacy tag reports)
  OM_CL_PC_BACKGROUND_RACE_ETNICITY_SELECT:
    'om_cl_pc_background_race_etnicity_select',
  OM_CL_PC_BACKGROUND_RELIGIONS_SELECT: 'om_cl_pc_background_religions_select',
  OM_CL_PC_BACKGROUND_POLITICAL_SELECT: 'om_cl_pc_background_political_select',
  // Pronoun select (distinct from combined YN + select composite)
  OM_CL_PC_BACKGROUND_PRONOUN_SELECT: 'om_cl_pc_background_pronoun_select',
  // Unspecified background placeholder (captures incomplete tag 'om_cl_pc_background_')
  OM_CL_PC_BACKGROUND_UNSPEC: 'om_cl_pc_background_',

  // Clinician section tags
  OM_CL_PC_SECTION_COMM_STYLE: 'om_cl_pc_comm_style',
  OM_CL_PC_SECTION_CARE_APPROACH: 'om_cl_pc_care_approach',
  OM_CL_PC_SECTION_BACKGROUND: 'om_cl_pc_background',

  // Clinician communication style
  OM_CL_PC_COMM_STYLE: 'om_cl_pc_comm_style',
  OM_CL_PC_COMM_STYLE_CONVERSATION_Lead:
    'om_cl_pc_comm_style_conversation_lead',
  OM_CL_PC_COMM_STYLE_DECISION_MAKER: 'om_cl_pc_comm_style_decision_maker',
  OM_CL_PC_COMM_STYLE_RESEARCH_SYMPTOMS:
    'om_cl_pc_comm_style_research_symptoms',
  OM_CL_PC_COMM_STYLE_DIAGNOSIS_TREATMENT:
    'om_cl_pc_comm_style_diagnosis_treatment',
  OM_CL_PC_COMM_STYLE_LIST_QS: 'om_cl_pc_comm_style_list_questions',
  OM_CL_PC_COMM_STYLE_EXPLAINING_THINGS_PA:
    'om_cl_pc_comm_style_explaining_things_pa',
  OM_CL_PC_COMM_STYLE_EDUCATIONAL_MATERIALS_PA:
    'om_cl_pc_comm_style_educational_materials_pa',
  OM_CL_PC_COMM_STYLE_DURING_APPOINTMENT:
    'om_cl_pc_comm_style_during_appointment',
  OM_CL_PC_COMM_STYLE_JOB_HEALTHY: 'om_cl_pc_comm_style_job_healthy',
  OM_CL_PC_COMM_STYLE_CASUAL_OR_PROF: 'om_cl_pc_comm_style_casual_or_prof',
  OM_CL_PC_CARE_NEW_DIET_SUPPORT: 'om_cl_pc_care_new_diet_support',
  OM_CL_PC_COMM_STYLE_PRAYING_YN: 'om_cl_pc_comm_style_praying_yn',
  OM_CL_PC_COMM_STYLE_ANOTHER_CLINICIAN_YN:
    'om_cl_pc_comm_style_another_clinician_yn',
  // Clinician care approach
  OM_CL_PC_CARE_APPROACH: 'om_cl_pc_care_approach',
  OM_CL_PC_CARE_APPROACH_CLINICAL_SERVICES:
    'om_cl_pc_care_approach_clinical_services',
  OM_CL_PC_CARE_APPROACH_PRESCRIPTION_SELECT:
    'om_cl_pc_care_approach_prescription_select',
  OM_CL_PC_VACCINATION_SCREENINGS: 'om_cl_pc_vaccination_screenings',
  OM_CL_PC_CARE_TRAINING_EXP: 'om_cl_pc_care_training_exp',
  OM_CL_PC_CARE_BIPOC_PA: 'om_cl_pc_care_bipoc_pa',
  OM_CL_PC_CARE_BODY_POSITIVE_APPROACH: 'om_cl_pc_care_body_positive_approach',
  OM_CL_PC_CARE_SUPPORTING_PA_CAREGIVERS:
    'om_cl_pc_care_supporting_pa_caregivers',
  OM_CL_PC_CARE_COMMUNICATING_UNIQUE_NEEDS_PA:
    'om_cl_pc_care_communicating_unique_needs_pa',
  OM_CL_PC_CARE_END_OF_LIFE_CARE: 'om_cl_pc_care_end_of_life_care',
  OM_CL_PC_CARE_GENDER_AFFIRMING: 'om_cl_pc_care_gender_affirming',
  OM_CL_PC_CARE_IMMIGRANTS_REFUGEES: 'om_cl_pc_care_immigrants_refugees',
  OM_CL_PC_CARE_LGBTQ_PA: 'om_cl_pc_care_LGBTQ_pa',
  OM_CL_PC_CARE_COMPREH_MENS_CARE: 'om_cl_pc_care_compreh_mens_care',
  OM_CL_PC_CARE_COMPREH_WOMENS_CARE: 'om_cl_pc_care_compreh_womens_care',
  OM_CL_PC_CARE_PERIOD_POSITIVE_CARE: 'om_cl_pc_care_period_positive_care',
  OM_CL_PC_CARE_SEX_POSITIVE_CARE: 'om_cl_pc_care_sex_positive_care',
  OM_CL_PC_CARE_SUBSTANCE_USE_ADDICTION:
    'om_cl_pc_care_substance_use_addiction',
  OM_CL_PC_CARE_NEURO_DIVERSITY: 'om_cl_pc_care_neuro_diversity',
  OM_CL_PC_CARE_TRAUMA_INFORMED: 'om_cl_pc_care_trauma_informed',
  OM_CL_PC_CARE_VETERANS: 'om_cl_pc_care_veterans',
  OM_CL_PC_CARE_SPIRITUAL_SUPPORT: 'om_cl_pc_care_spiritual_support',
  OM_CL_PC_BACKGROUND_LANGUAGE_SELECT: 'om_cl_pc_background_language_select',
  OM_CL_PC_BACKGROUND_YOE: 'om_cl_pc_background_yoe',
  OM_CL_PC_BACKGROUND_PREFER_PA_ADDRESS:
    'om_cl_pc_background_prefer_pa_address',
  OM_CL_PC_BACKGROUND_SEXUAL_ORIENTATION:
    'om_cl_pc_background_sexual_orientation',
  OM_CL_PC_BACKGROUND_MILITARY_YN: 'om_cl_pc_background_military_yn',
  OM_CL_PC_BACKGROUND_POLITICAL_PARTY: 'om_cl_pc_background_political_party',
  OM_CL_PC_CARE_APPROACH_KNOWLEDGE_EXP: 'om_cl_pc_care_approach_knowledge_exp',
  OM_CL_PC_CARE_APPROACH_OPINION: 'om_cl_pc_care_approach_opinion',
  OM_CL_PC_CARE_CANCER_MENTAL_PHYSICAL: 'om_cl_pc_care_cancer_mental_physical',
  OM_CL_PC_CARE_FAMILY_CENTERED_CARE: 'om_cl_pc_care_family_centered_care',
  OM_CL_PC_CARE_APPROACH_NATURAL_INTEGRATIVE_SELECT:
    'om_cl_pc_care_approach_natural_integrative_select',
  OM_CL_PC_CARE_APPROACH_DIETS_SELECT: 'om_cl_pc_care_approach_diets_select',
} as const

export type TagKey = keyof typeof TAGS
export type TagValue = (typeof TAGS)[TagKey]
